// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Preview Panel ── */
.dp-preview {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.dp-preview__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
  flex-shrink: 0;
}

.dp-preview__header h3 {
  margin: 0;
  font-size: var(--dp-font-size-md);
  color: var(--dp-color-text);
}

.dp-preview__scan-btn {
  padding: var(--dp-spacing-xs) var(--dp-spacing-md);
  background: var(--dp-color-surface);
  color: var(--dp-color-primary);
  border: var(--dp-border-width-thin) solid var(--dp-color-primary);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  cursor: pointer;
  transition: all 0.12s;
}
.dp-preview__scan-btn:hover {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
}
.dp-preview__scan-btn:disabled { opacity: 0.5; cursor: not-allowed; }

/* ── Scrollable fields area ── */
.dp-preview__fields {
  flex: 1;
  overflow-y: auto;
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
}

.dp-preview__empty {
  text-align: center;
  padding: var(--dp-spacing-lg);
  color: var(--dp-color-text-secondary);
  font-size: var(--dp-font-size-sm);
}

.dp-preview__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--dp-spacing-sm);
  padding: var(--dp-spacing-lg);
  color: var(--dp-color-text-secondary);
  font-size: var(--dp-font-size-sm);
}

.dp-preview__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--dp-color-border);
  border-top-color: var(--dp-color-primary);
  border-radius: 50%;
  animation: dp-preview-spin 0.6s linear infinite;
}

@keyframes dp-preview-spin {
  to { transform: rotate(360deg); }
}

.dp-preview__warning {
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  background: #fff3e0;
  color: #e65100;
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  margin-bottom: var(--dp-spacing-sm);
}

/* ── Sections ── */
.dp-preview__section {
  margin-bottom: var(--dp-spacing-md);
}

.dp-preview__section-title {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--dp-color-text-secondary);
  padding: var(--dp-spacing-xs) 0;
  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);
  margin-bottom: var(--dp-spacing-xs);
}

/* ── Field rows ── */
.dp-preview__field {
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  margin-bottom: var(--dp-spacing-xs);
  transition: border-color 0.12s;
}

.dp-preview__field:hover {
  border-color: var(--dp-color-primary);
}

.dp-preview__field--error {
  border-color: var(--dp-color-error);
  background: #fff8f8;
}

.dp-preview__field--conditional {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* ── Field label ── */
.dp-preview__field-label {
  display: flex;
  align-items: center;
  gap: var(--dp-spacing-xs);
  margin-bottom: 4px;
}

.dp-preview__field--conditional .dp-preview__field-label {
  margin-bottom: 0;
  flex: 1;
  min-width: 0;
}

.dp-preview__field-name {
  font-family: monospace;
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dp-preview__field-type {
  font-size: 9px;
  font-weight: var(--dp-font-weight-bold);
  padding: 1px 5px;
  border-radius: var(--dp-border-radius-sm);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  flex-shrink: 0;
}

.dp-preview__field-type--text    { background: #e3f2fd; color: #1565c0; }
.dp-preview__field-type--date    { background: #f3e5f5; color: #7b1fa2; }
.dp-preview__field-type--number  { background: #e8f5e9; color: #2e7d32; }
.dp-preview__field-type--money   { background: #fff8e1; color: #f57f17; }
.dp-preview__field-type--boolean { background: #fce4ec; color: #c62828; }
.dp-preview__field-type--address { background: #e0f2f1; color: #00695c; }
.dp-preview__field-type--list    { background: #ede7f6; color: #4527a0; }

.dp-preview__field-required {
  color: var(--dp-color-error);
  font-weight: bold;
  font-size: var(--dp-font-size-xs);
}

/* ── Inputs ── */
.dp-preview__input {
  width: 100%;
  padding: var(--dp-spacing-xs);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  box-sizing: border-box;
  transition: border-color 0.12s;
}
.dp-preview__input:focus {
  border-color: var(--dp-color-primary);
  outline: none;
}

.dp-preview__textarea {
  width: 100%;
  padding: var(--dp-spacing-xs);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  font-family: monospace;
  box-sizing: border-box;
  resize: vertical;
  min-height: 40px;
}
.dp-preview__textarea:focus {
  border-color: var(--dp-color-primary);
  outline: none;
}

.dp-preview__checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text);
  cursor: pointer;
}
.dp-preview__checkbox input[type="checkbox"] {
  width: 14px;
  height: 14px;
  accent-color: var(--dp-color-primary);
}

.dp-preview__format-hint {
  display: block;
  font-size: 10px;
  color: var(--dp-color-text-secondary);
  margin-top: 2px;
}

/* ── Toggle switch (reuse conditional pattern) ── */
.dp-preview__toggle {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  cursor: pointer;
}
.dp-preview__toggle input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.dp-preview__toggle-slider {
  display: inline-block;
  width: 32px;
  height: 18px;
  background: #9CA3AF;
  border-radius: 9px;
  position: relative;
  transition: background 0.2s;
}
.dp-preview__toggle-slider::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}
.dp-preview__toggle input[type="checkbox"]:checked + .dp-preview__toggle-slider {
  background: #10B981;
}
.dp-preview__toggle input[type="checkbox"]:checked + .dp-preview__toggle-slider::after {
  transform: translateX(14px);
}
.dp-preview__toggle-label {
  font-size: 10px;
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text-secondary);
  min-width: 22px;
}

/* ── Conditional badges ── */
.dp-preview__cond-badge {
  font-size: 9px;
  font-weight: var(--dp-font-weight-bold);
  padding: 1px 6px;
  border-radius: var(--dp-border-radius-sm);
  text-transform: uppercase;
  letter-spacing: 0.03em;
  flex-shrink: 0;
}
.dp-preview__cond-badge--if {
  background: #d1fae5;
  color: #065f46;
}
.dp-preview__cond-badge--unless {
  background: #fef3c7;
  color: #92400e;
}

/* ── Repeat sections ── */
.dp-preview__repeat {
  padding: var(--dp-spacing-sm);
}

.dp-preview__repeat-badge {
  font-size: 9px;
  font-weight: var(--dp-font-weight-bold);
  padding: 1px 6px;
  border-radius: var(--dp-border-radius-sm);
  background: #e8f5e9;
  color: #2e7d32;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  flex-shrink: 0;
}

.dp-preview__repeat-row {
  display: flex;
  align-items: flex-start;
  gap: var(--dp-spacing-xs);
  padding: var(--dp-spacing-xs);
  margin-top: var(--dp-spacing-xs);
  background: #f8f9fc;
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
}

.dp-preview__repeat-row-num {
  font-size: 10px;
  font-weight: var(--dp-font-weight-bold);
  color: var(--dp-color-text-secondary);
  padding-top: 4px;
  flex-shrink: 0;
  min-width: 18px;
}

.dp-preview__repeat-row-fields {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dp-preview__repeat-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dp-preview__repeat-cell-label {
  font-size: 10px;
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text-secondary);
  min-width: 50px;
  flex-shrink: 0;
}

.dp-preview__repeat-remove {
  background: none;
  border: none;
  cursor: pointer;
  color: #c62828;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: var(--dp-border-radius-sm);
  flex-shrink: 0;
  align-self: flex-start;
  margin-top: 2px;
}
.dp-preview__repeat-remove:hover {
  background: #fde8e8;
}

.dp-preview__repeat-add {
  background: none;
  border: 1px dashed var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  color: var(--dp-color-primary);
  font-size: var(--dp-font-size-xs);
  padding: 4px 8px;
  cursor: pointer;
  text-align: center;
  margin-top: var(--dp-spacing-xs);
  width: 100%;
  transition: all 0.12s;
}
.dp-preview__repeat-add:hover {
  background: var(--dp-color-surface);
  border-color: var(--dp-color-primary);
}

/* ── Preview result bar ── */
.dp-preview__result-bar {
  display: flex;
  align-items: center;
  gap: var(--dp-spacing-xs);
  padding: var(--dp-spacing-xs) var(--dp-spacing-md);
  background: #e8f5e9;
  border-top: var(--dp-border-width-thin) solid #a5d6a7;
  flex-shrink: 0;
}

.dp-preview__result-text {
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  color: #2e7d32;
  flex: 1;
}

.dp-preview__result-btn {
  padding: 3px 10px;
  font-size: 11px;
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  cursor: pointer;
  background: var(--dp-color-background);
  color: var(--dp-color-text);
  transition: all 0.12s;
}
.dp-preview__result-btn:hover {
  background: var(--dp-color-surface-hover);
}
.dp-preview__result-btn--primary {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border-color: var(--dp-color-primary);
}
.dp-preview__result-btn--primary:hover {
  background: var(--dp-color-primary-hover);
}
.dp-preview__result-btn--dismiss {
  color: var(--dp-color-text-secondary);
  border-color: transparent;
  background: transparent;
}
.dp-preview__result-btn--dismiss:hover {
  color: var(--dp-color-text);
  background: var(--dp-color-surface-hover);
}

/* ── Messages ── */
.dp-preview__message {
  padding: var(--dp-spacing-xs) var(--dp-spacing-md);
  font-size: var(--dp-font-size-xs);
  text-align: center;
  flex-shrink: 0;
}
.dp-preview__message--info {
  background: var(--dp-color-surface);
  color: var(--dp-color-text-secondary);
}
.dp-preview__message--error {
  background: #fde8e8;
  color: var(--dp-color-error);
}
.dp-preview__message--success {
  background: #e8f5e9;
  color: #2e7d32;
}

/* ── Progress indicator ── */
.dp-preview__progress {
  display: flex;
  align-items: center;
  gap: var(--dp-spacing-sm);
  padding: var(--dp-spacing-xs) var(--dp-spacing-md);
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-primary);
  flex-shrink: 0;
}

.dp-preview__progress-bar {
  width: 100%;
  height: 3px;
  background: var(--dp-color-border);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
  flex: 1;
}
.dp-preview__progress-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 40%;
  background: var(--dp-color-primary);
  border-radius: 2px;
  animation: dp-preview-progress 1.2s ease-in-out infinite;
}

@keyframes dp-preview-progress {
  0%   { left: -40%; }
  100% { left: 100%; }
}

/* ── Sticky action bar ── */
.dp-preview__actions {
  display: flex;
  gap: var(--dp-spacing-xs);
  padding: var(--dp-spacing-sm) var(--dp-spacing-md);
  border-top: var(--dp-border-width-thin) solid var(--dp-color-border);
  background: var(--dp-color-background);
  flex-shrink: 0;
  flex-wrap: wrap;
}

.dp-preview__action-btn {
  flex: 1;
  min-width: 0;
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
  transition: all 0.12s;
  white-space: nowrap;
  text-align: center;
}
.dp-preview__action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dp-preview__action-btn--primary {
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border: none;
}
.dp-preview__action-btn--primary:hover:not(:disabled) {
  background: var(--dp-color-primary-hover);
}

.dp-preview__action-btn--secondary {
  background: #f3e5f5;
  color: #7b1fa2;
  border: var(--dp-border-width-thin) solid #ce93d8;
}
.dp-preview__action-btn--secondary:hover:not(:disabled) {
  background: #e1bee7;
}

.dp-preview__action-btn--outline {
  background: var(--dp-color-background);
  color: var(--dp-color-primary);
  border: var(--dp-border-width-thin) solid var(--dp-color-primary);
}
.dp-preview__action-btn--outline:hover:not(:disabled) {
  background: var(--dp-color-surface);
}

.dp-preview__action-btn--ghost {
  background: transparent;
  color: var(--dp-color-text-secondary);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
}
.dp-preview__action-btn--ghost:hover:not(:disabled) {
  background: var(--dp-color-surface-hover);
  color: var(--dp-color-text);
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/PreviewPanel.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;EAClD,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,kDAAkD;EAClD,mCAAmC;EACnC,8BAA8B;EAC9B,iEAAiE;EACjE,yCAAyC;EACzC,iCAAiC;EACjC,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,mCAAmC;AACrC;AACA,iCAAiC,YAAY,EAAE,mBAAmB,EAAE;;AAEpE,iCAAiC;AACjC;EACE,OAAO;EACP,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,yCAAyC;EACzC,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kDAAkD;EAClD,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qCAAqC;EACrC,+BAA+B;EAC/B,uEAAuE;EACvE,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,gEAAgE;EAChE,yCAAyC;EACzC,kDAAkD;EAClD,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,2CAA2C;EAC3C,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;;AAExE;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,6BAA6B;EAC7B,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,gEAAgE;EAChE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,yCAAyC;EACzC,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,mBAAmB;EACnB,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;EACd,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gEAAgE;EAChE,yCAAyC;EACzC,eAAe;EACf,sCAAsC;EACtC,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,kDAAkD;EAClD,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kDAAkD;EAClD,iCAAiC;EACjC,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,UAAU;EACV,mCAAmC;EACnC,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,yBAAyB;EACzB,kDAAkD;EAClD,oEAAoE;EACpE,sCAAsC;EACtC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,kDAAkD;EAClD,yCAAyC;EACzC,iCAAiC;EACjC,2CAA2C;EAC3C,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iDAAiD;AACnD;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;EAC9B,iEAAiE;AACnE;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,gEAAgE;AAClE;AACA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B","sourcesContent":["/* ── Preview Panel ── */\n.dp-preview {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n\n.dp-preview__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n  flex-shrink: 0;\n}\n\n.dp-preview__header h3 {\n  margin: 0;\n  font-size: var(--dp-font-size-md);\n  color: var(--dp-color-text);\n}\n\n.dp-preview__scan-btn {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-md);\n  background: var(--dp-color-surface);\n  color: var(--dp-color-primary);\n  border: var(--dp-border-width-thin) solid var(--dp-color-primary);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  cursor: pointer;\n  transition: all 0.12s;\n}\n.dp-preview__scan-btn:hover {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n}\n.dp-preview__scan-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* ── Scrollable fields area ── */\n.dp-preview__fields {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n}\n\n.dp-preview__empty {\n  text-align: center;\n  padding: var(--dp-spacing-lg);\n  color: var(--dp-color-text-secondary);\n  font-size: var(--dp-font-size-sm);\n}\n\n.dp-preview__loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--dp-spacing-sm);\n  padding: var(--dp-spacing-lg);\n  color: var(--dp-color-text-secondary);\n  font-size: var(--dp-font-size-sm);\n}\n\n.dp-preview__spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--dp-color-border);\n  border-top-color: var(--dp-color-primary);\n  border-radius: 50%;\n  animation: dp-preview-spin 0.6s linear infinite;\n}\n\n@keyframes dp-preview-spin {\n  to { transform: rotate(360deg); }\n}\n\n.dp-preview__warning {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  background: #fff3e0;\n  color: #e65100;\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  margin-bottom: var(--dp-spacing-sm);\n}\n\n/* ── Sections ── */\n.dp-preview__section {\n  margin-bottom: var(--dp-spacing-md);\n}\n\n.dp-preview__section-title {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--dp-color-text-secondary);\n  padding: var(--dp-spacing-xs) 0;\n  border-bottom: var(--dp-border-width-thin) solid var(--dp-color-border);\n  margin-bottom: var(--dp-spacing-xs);\n}\n\n/* ── Field rows ── */\n.dp-preview__field {\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  margin-bottom: var(--dp-spacing-xs);\n  transition: border-color 0.12s;\n}\n\n.dp-preview__field:hover {\n  border-color: var(--dp-color-primary);\n}\n\n.dp-preview__field--error {\n  border-color: var(--dp-color-error);\n  background: #fff8f8;\n}\n\n.dp-preview__field--conditional {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n/* ── Field label ── */\n.dp-preview__field-label {\n  display: flex;\n  align-items: center;\n  gap: var(--dp-spacing-xs);\n  margin-bottom: 4px;\n}\n\n.dp-preview__field--conditional .dp-preview__field-label {\n  margin-bottom: 0;\n  flex: 1;\n  min-width: 0;\n}\n\n.dp-preview__field-name {\n  font-family: monospace;\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dp-preview__field-type {\n  font-size: 9px;\n  font-weight: var(--dp-font-weight-bold);\n  padding: 1px 5px;\n  border-radius: var(--dp-border-radius-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  flex-shrink: 0;\n}\n\n.dp-preview__field-type--text    { background: #e3f2fd; color: #1565c0; }\n.dp-preview__field-type--date    { background: #f3e5f5; color: #7b1fa2; }\n.dp-preview__field-type--number  { background: #e8f5e9; color: #2e7d32; }\n.dp-preview__field-type--money   { background: #fff8e1; color: #f57f17; }\n.dp-preview__field-type--boolean { background: #fce4ec; color: #c62828; }\n.dp-preview__field-type--address { background: #e0f2f1; color: #00695c; }\n.dp-preview__field-type--list    { background: #ede7f6; color: #4527a0; }\n\n.dp-preview__field-required {\n  color: var(--dp-color-error);\n  font-weight: bold;\n  font-size: var(--dp-font-size-xs);\n}\n\n/* ── Inputs ── */\n.dp-preview__input {\n  width: 100%;\n  padding: var(--dp-spacing-xs);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  box-sizing: border-box;\n  transition: border-color 0.12s;\n}\n.dp-preview__input:focus {\n  border-color: var(--dp-color-primary);\n  outline: none;\n}\n\n.dp-preview__textarea {\n  width: 100%;\n  padding: var(--dp-spacing-xs);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  font-family: monospace;\n  box-sizing: border-box;\n  resize: vertical;\n  min-height: 40px;\n}\n.dp-preview__textarea:focus {\n  border-color: var(--dp-color-primary);\n  outline: none;\n}\n\n.dp-preview__checkbox {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text);\n  cursor: pointer;\n}\n.dp-preview__checkbox input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  accent-color: var(--dp-color-primary);\n}\n\n.dp-preview__format-hint {\n  display: block;\n  font-size: 10px;\n  color: var(--dp-color-text-secondary);\n  margin-top: 2px;\n}\n\n/* ── Toggle switch (reuse conditional pattern) ── */\n.dp-preview__toggle {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n.dp-preview__toggle input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.dp-preview__toggle-slider {\n  display: inline-block;\n  width: 32px;\n  height: 18px;\n  background: #9CA3AF;\n  border-radius: 9px;\n  position: relative;\n  transition: background 0.2s;\n}\n.dp-preview__toggle-slider::after {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 14px;\n  height: 14px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 0.2s;\n}\n.dp-preview__toggle input[type=\"checkbox\"]:checked + .dp-preview__toggle-slider {\n  background: #10B981;\n}\n.dp-preview__toggle input[type=\"checkbox\"]:checked + .dp-preview__toggle-slider::after {\n  transform: translateX(14px);\n}\n.dp-preview__toggle-label {\n  font-size: 10px;\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text-secondary);\n  min-width: 22px;\n}\n\n/* ── Conditional badges ── */\n.dp-preview__cond-badge {\n  font-size: 9px;\n  font-weight: var(--dp-font-weight-bold);\n  padding: 1px 6px;\n  border-radius: var(--dp-border-radius-sm);\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  flex-shrink: 0;\n}\n.dp-preview__cond-badge--if {\n  background: #d1fae5;\n  color: #065f46;\n}\n.dp-preview__cond-badge--unless {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n/* ── Repeat sections ── */\n.dp-preview__repeat {\n  padding: var(--dp-spacing-sm);\n}\n\n.dp-preview__repeat-badge {\n  font-size: 9px;\n  font-weight: var(--dp-font-weight-bold);\n  padding: 1px 6px;\n  border-radius: var(--dp-border-radius-sm);\n  background: #e8f5e9;\n  color: #2e7d32;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  flex-shrink: 0;\n}\n\n.dp-preview__repeat-row {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--dp-spacing-xs);\n  padding: var(--dp-spacing-xs);\n  margin-top: var(--dp-spacing-xs);\n  background: #f8f9fc;\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n}\n\n.dp-preview__repeat-row-num {\n  font-size: 10px;\n  font-weight: var(--dp-font-weight-bold);\n  color: var(--dp-color-text-secondary);\n  padding-top: 4px;\n  flex-shrink: 0;\n  min-width: 18px;\n}\n\n.dp-preview__repeat-row-fields {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.dp-preview__repeat-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.dp-preview__repeat-cell-label {\n  font-size: 10px;\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text-secondary);\n  min-width: 50px;\n  flex-shrink: 0;\n}\n\n.dp-preview__repeat-remove {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #c62828;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 2px 6px;\n  border-radius: var(--dp-border-radius-sm);\n  flex-shrink: 0;\n  align-self: flex-start;\n  margin-top: 2px;\n}\n.dp-preview__repeat-remove:hover {\n  background: #fde8e8;\n}\n\n.dp-preview__repeat-add {\n  background: none;\n  border: 1px dashed var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  color: var(--dp-color-primary);\n  font-size: var(--dp-font-size-xs);\n  padding: 4px 8px;\n  cursor: pointer;\n  text-align: center;\n  margin-top: var(--dp-spacing-xs);\n  width: 100%;\n  transition: all 0.12s;\n}\n.dp-preview__repeat-add:hover {\n  background: var(--dp-color-surface);\n  border-color: var(--dp-color-primary);\n}\n\n/* ── Preview result bar ── */\n.dp-preview__result-bar {\n  display: flex;\n  align-items: center;\n  gap: var(--dp-spacing-xs);\n  padding: var(--dp-spacing-xs) var(--dp-spacing-md);\n  background: #e8f5e9;\n  border-top: var(--dp-border-width-thin) solid #a5d6a7;\n  flex-shrink: 0;\n}\n\n.dp-preview__result-text {\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  color: #2e7d32;\n  flex: 1;\n}\n\n.dp-preview__result-btn {\n  padding: 3px 10px;\n  font-size: 11px;\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  cursor: pointer;\n  background: var(--dp-color-background);\n  color: var(--dp-color-text);\n  transition: all 0.12s;\n}\n.dp-preview__result-btn:hover {\n  background: var(--dp-color-surface-hover);\n}\n.dp-preview__result-btn--primary {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border-color: var(--dp-color-primary);\n}\n.dp-preview__result-btn--primary:hover {\n  background: var(--dp-color-primary-hover);\n}\n.dp-preview__result-btn--dismiss {\n  color: var(--dp-color-text-secondary);\n  border-color: transparent;\n  background: transparent;\n}\n.dp-preview__result-btn--dismiss:hover {\n  color: var(--dp-color-text);\n  background: var(--dp-color-surface-hover);\n}\n\n/* ── Messages ── */\n.dp-preview__message {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-md);\n  font-size: var(--dp-font-size-xs);\n  text-align: center;\n  flex-shrink: 0;\n}\n.dp-preview__message--info {\n  background: var(--dp-color-surface);\n  color: var(--dp-color-text-secondary);\n}\n.dp-preview__message--error {\n  background: #fde8e8;\n  color: var(--dp-color-error);\n}\n.dp-preview__message--success {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n/* ── Progress indicator ── */\n.dp-preview__progress {\n  display: flex;\n  align-items: center;\n  gap: var(--dp-spacing-sm);\n  padding: var(--dp-spacing-xs) var(--dp-spacing-md);\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-primary);\n  flex-shrink: 0;\n}\n\n.dp-preview__progress-bar {\n  width: 100%;\n  height: 3px;\n  background: var(--dp-color-border);\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n  flex: 1;\n}\n.dp-preview__progress-bar::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 40%;\n  background: var(--dp-color-primary);\n  border-radius: 2px;\n  animation: dp-preview-progress 1.2s ease-in-out infinite;\n}\n\n@keyframes dp-preview-progress {\n  0%   { left: -40%; }\n  100% { left: 100%; }\n}\n\n/* ── Sticky action bar ── */\n.dp-preview__actions {\n  display: flex;\n  gap: var(--dp-spacing-xs);\n  padding: var(--dp-spacing-sm) var(--dp-spacing-md);\n  border-top: var(--dp-border-width-thin) solid var(--dp-color-border);\n  background: var(--dp-color-background);\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.dp-preview__action-btn {\n  flex: 1;\n  min-width: 0;\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n  transition: all 0.12s;\n  white-space: nowrap;\n  text-align: center;\n}\n.dp-preview__action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.dp-preview__action-btn--primary {\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border: none;\n}\n.dp-preview__action-btn--primary:hover:not(:disabled) {\n  background: var(--dp-color-primary-hover);\n}\n\n.dp-preview__action-btn--secondary {\n  background: #f3e5f5;\n  color: #7b1fa2;\n  border: var(--dp-border-width-thin) solid #ce93d8;\n}\n.dp-preview__action-btn--secondary:hover:not(:disabled) {\n  background: #e1bee7;\n}\n\n.dp-preview__action-btn--outline {\n  background: var(--dp-color-background);\n  color: var(--dp-color-primary);\n  border: var(--dp-border-width-thin) solid var(--dp-color-primary);\n}\n.dp-preview__action-btn--outline:hover:not(:disabled) {\n  background: var(--dp-color-surface);\n}\n\n.dp-preview__action-btn--ghost {\n  background: transparent;\n  color: var(--dp-color-text-secondary);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n}\n.dp-preview__action-btn--ghost:hover:not(:disabled) {\n  background: var(--dp-color-surface-hover);\n  color: var(--dp-color-text);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
